"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 9.4.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FoundRequisitionDtoOrderTypeEnum = void 0;
exports.FoundRequisitionDtoOrderTypeEnum = {
    Diagnostic: 'diagnostic',
    Preventive: 'preventive',
    SmaStat: 'sma-stat',
    Stat: 'stat',
    Exome: 'exome',
    ExomePreventiveAddon: 'exome_preventive_addon',
    Carrier: 'carrier',
    Nips: 'nips',
    TumorProfiling: 'tumor_profiling',
    CombiPoc: 'combi_poc',
    CombiRpl: 'combi_rpl',
    CombiCdd: 'combi_cdd',
    CombiPd: 'combi_pd',
    CombiCc: 'combi_cc',
    CombiPfu: 'combi_pfu',
    Wgs: 'wgs',
    Pathogen: 'pathogen',
    Pgx: 'pgx',
    SolidTumor: 'solid_tumor'
};
